import clsx from 'clsx';
import type { HTMLAttributes, ForwardRefRenderFunction } from 'react';
import { forwardRef } from 'react';

interface SidebarFooterProps extends HTMLAttributes<HTMLDivElement> {
	children?: React.ReactNode;
	className?: string;
}

const SidebarFooter: ForwardRefRenderFunction<
	HTMLDivElement,
	SidebarFooterProps
> = ({ children, className, ...rest }, ref) => {
	return (
		<div
			ref={ref}
			className={clsx('sideNav-footer', className)}
			{...rest}
		>
			{children}
		</div>
	);
};

export default forwardRef(SidebarFooter);
